import { Button, Popover, Space } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';
import { type UserSchema } from 'stores/User';

const TriggerContainer = styled.button`
  position: absolute;
  bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  width: 100%;
  cursor: pointer;
  overflow: hidden;
  border: none;
  height: 35px;
`;

const TriggerIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  width: 35px;
  border-radius: 35px;
  background: #efefef;
  overflow: hidden;
`;

const PanelContainer = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
`;

const PanelIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 64px;
  width: 64px;
  border-radius: 64px;
  border: 1px solid #bdbdbd;
  background: #efefef;
  overflow: hidden;
`;

const PanelInfo = styled.div`
  margin: 0 0 0 17px;
`;

const PanelName = styled.div`
  font-size: 20px;
`;

const PanelEmail = styled.div`
  font-size: 12px;
  margin-bottom: 10px;
`;

const FillImage = styled.img`
  width: 100%;
  height: 100%;
`;

interface UserPanelProps {
  userData: UserSchema;
  onViewProfileClick?: () => void;
  onLogoutClick?: () => void;
}

function UserPanel({
  userData,
  onViewProfileClick,
  onLogoutClick,
}: UserPanelProps) {
  return (
    <PanelContainer>
      <PanelIconWrapper>
        <FillImage alt="User Photo" src={userData.cachedPhotoURL} />
      </PanelIconWrapper>
      <PanelInfo>
        <PanelName>{userData.displayName}</PanelName>
        <PanelEmail>{userData.email}</PanelEmail>
        <Space>
          <Button onClick={onViewProfileClick} type="primary">
            View Profile
          </Button>
          <Button onClick={onLogoutClick}>Sign Out</Button>
        </Space>
      </PanelInfo>
    </PanelContainer>
  );
}

function UserButton() {
  const store_router = store.router;
  const store_routes = store.routes;
  const store_user = store.user;

  const [isOpen, setIsOpen] = useState(false);

  const handleShowUser = () => {
    setIsOpen(false);
    void store_router.goTo(store_routes.profile);
  };

  const handleLogout = () => {
    setIsOpen(false);
    store_user.logout();
  };

  return (
    <Popover
      content={
        <UserPanel
          userData={store_user.data}
          onViewProfileClick={handleShowUser}
          onLogoutClick={handleLogout}
        />
      }
      placement="leftBottom"
      trigger="hover"
      open={isOpen}
      onOpenChange={(newOpenState) => setIsOpen(newOpenState)}
    >
      <TriggerContainer>
        <TriggerIconWrapper>
          <FillImage alt="User Photo" src={store_user.data.cachedPhotoURL} />
        </TriggerIconWrapper>
      </TriggerContainer>
    </Popover>
  );
}

export default observer(UserButton);
